import { Controller } from "@hotwired/stimulus"
import { loadVendor } from "../lib/load_vendor"

// hls.js (~505KB) is NOT bundled here — it's lazy-loaded the first time a video
// actually plays (lib/load_vendor → hls_vendor.js sets window.Hls), keeping it
// out of the universal application.js. The controller stays in the normal
// Stimulus manifest, so it registers/connects exactly as before.
export default class extends Controller {
  static targets = [ "video" ]
  static values = { src: String }

  async connect() {
    if (!this.srcValue || !this.hasVideoTarget) return
    const video = this.videoTarget
    this._disposed = false

    try {
      await loadVendor("hls")
    } catch (e) {
      console.error("[video-player]", e)
      // Fallback to native HLS (Safari/iOS) if the library failed to load.
      if (video.canPlayType("application/vnd.apple.mpegurl")) video.src = this.srcValue
      return
    }
    if (this._disposed) return // disconnected while the library was loading

    const Hls = window.Hls
    if (Hls && Hls.isSupported()) {
      const hls = new Hls()
      hls.loadSource(this.srcValue)
      hls.attachMedia(video)
      this._hls = hls
    } else if (video.canPlayType("application/vnd.apple.mpegurl")) {
      video.src = this.srcValue
    }
  }

  disconnect() {
    this._disposed = true
    if (this._hls) {
      this._hls.destroy()
      this._hls = null
    }
  }
}
